import { render } from "./TransportDashboard.vue?vue&type=template&id=1ab15cf0&scoped=true"
import script from "./TransportDashboard.vue?vue&type=script&lang=js"
export * from "./TransportDashboard.vue?vue&type=script&lang=js"

import "./TransportDashboard.vue?vue&type=style&index=0&id=1ab15cf0&lang=css"
import "./TransportDashboard.vue?vue&type=style&index=1&id=1ab15cf0&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab15cf0"]])

export default __exports__